<template>
  <div class="app-wrapper h-screen flex flex-col overflow-hidden">
    <div class="backimg"></div>

    <Navigation v-if="isAuthRoute" class="h-16 shrink-0" />

    <div class="flex-1 flex overflow-hidden">
      <div v-if="!storeReady" class="w-full h-full flex items-center justify-center">
        <div class="text-xl">Loading...</div>
      </div>

      <div v-else-if="!isAuthRoute" class="w-full h-full flex items-center justify-center">
        <RouterView />
      </div>

      <RouterView v-else class="w-full h-full" />
    </div>

    <PhoneComponent v-if="isAuthRoute && phoneVisible" class="shrink-0" />

    <IncomingVideoCall v-if="isAuthRoute" />
  </div>
</template>

<script>
import { computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Navigation from './views/Navigation.vue'
import PhoneComponent from './views/phone/PhoneComponent.vue'
import IncomingVideoCall from './components/IncomingVideoCall.vue'

export default {
  components: { Navigation, PhoneComponent, IncomingVideoCall },
  setup() {
    const store = useStore()
    const route = useRoute()

    const isAuthRoute = computed(() => route.meta.requiresAuth === true)
    const storeReady = computed(() => store.state.initialized)
    const phoneVisible = computed(() => store.state.phone?.ui?.visible === true)

    // Bootstrap SIP only in main window, not in meeting popups
    watchEffect(() => {
      if (window.opener) return
      const token = localStorage.getItem('token')
      if (storeReady.value && token) {
        store.dispatch('phone/bootstrap').catch(() => {})
      }
    })

    return {
      isAuthRoute,
      storeReady,
      phoneVisible
    }
  }
}
</script>

<style scoped>
.backimg {
  opacity: 0.50;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background: url('~@/assets/swirl_crop.jpg') no-repeat center center;
  background-color: #FFF;
  background-size: cover;
}

.router-view-content {
  height: 100%;
  width: 100%;
}
</style>
